import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { ConversationResponse } from "../types";
import axiosClient from "../utils/axiosClient";

export const useGetConversationByID = (
  id: number | string,
  refetchInterval?: number
) => {
  return useQuery<any, AxiosError<any>, ConversationResponse>(
    ["conversation", id],
    async () => {
      const data = await axiosClient.get<ConversationResponse>(
        `/conversation/get/${id}`
      );
      return data.data;
    },
    {
      refetchInterval: refetchInterval || false
    }
  );
};
